module.exports = __webpack_public_path__ + "img/norecover.a01455ca.svg";